import axios from 'axios';

import { CONFIG } from '@arrived/config';

/*
  We need to add the user's timezone to the requests made to our services so that we
  can generate trade document information pertaining to the user's timezone and not the timezone
  of our services.
*/
const apiFactory = (baseURL: string) =>
  axios.create({
    baseURL,
    headers: {
      'Content-type': 'application/json',
      Timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });

export const api = apiFactory(CONFIG.abacusApiRoot);
/**
 * Should not have interceptors or auth attached to it
 */
export const publicApi = apiFactory(CONFIG.abacusApiRoot);

export const rewardsApi = apiFactory(CONFIG.rewardsApiRoot);

export const strapiApi = apiFactory(CONFIG.arrivedCmsApiUrl);

export const marketingApi = apiFactory(CONFIG.marketingApiUrl);

export const wordpressApi = apiFactory(CONFIG.learnBlogUrl);

export const demioApi = apiFactory(CONFIG.demioApiRoot);

// Errors with Timezone header
export const affiliateApi = axios.create({ baseURL: CONFIG.marketing.tuneAffiliateBaseUrl });
